import {getInVk, getIsVkAppDesktop, setSnackbarMessage} from '@/composables/context'
import {phone, types} from '@/constants'
import {copyText} from '@/services/vkApi'

function _onCopyTextSuccess () {
  showToast('Номер скопирован в буфер обмена')
}

function copyToClipboard (text) {
  if (getInVk()) {
    copyText(text)
      .then(_onCopyTextSuccess)
  } else {
    const clipboard = navigator.clipboard
    if (clipboard) {
      clipboard.writeText(text).then(_onCopyTextSuccess)
    } else {
      const textarea = document.createElement('textarea')
      textarea.setAttribute('readonly', 'true')
      textarea.setAttribute('contenteditable', 'true')
      textarea.style.position = 'fixed'
      textarea.style.left = '0'
      textarea.style.top = '0'
      textarea.style.opacity = '0'
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.focus()
      textarea.select()

      const range = document.createRange()
      range.selectNodeContents(textarea)

      const sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(range)

      textarea.setSelectionRange(0, textarea.value.length)
      document.execCommand('copy')
      document.body.removeChild(textarea)
      _onCopyTextSuccess()
    }
  }
}

function fillDialogPosition(target, modalEl) {
  if (getIsVkAppDesktop()) {
    setTimeout(() => {
      const toTop = window.innerHeight - target.getBoundingClientRect().top < 700
      const top = toTop ? Math.max(window.innerHeight - 650, 0) : Math.max(target.getBoundingClientRect().top, 100)
      const modalHeight = modalEl.offsetHeight
      modalEl.style.position = 'absolute'
      modalEl.style.top = `${Math.max (0, top - modalHeight)}px`
    }, 0)
  }
}

function formatPaymentMethodNumber (info) {
  if (!info.value || !info.value.length || info.value.indexOf(' ') > -1
    || info.value.indexOf('-') > -1 || info.value.indexOf('(') > -1 || info.value.indexOf(')') > -1) {
    return info.value
  }
  let formattedVal = ''
  switch (info.type) {
    case types.paymentInfo.account.id:
      formattedVal = _formatAccountNumber(info.value)
      break;
    case types.paymentInfo.card.id:
      formattedVal = _formatCardNumber(info.value)
      break;
    case types.paymentInfo.cash.id:
      formattedVal = info.value
      break;
    case types.paymentInfo.phone.id:
      formattedVal = formatPhoneNumber(info.value)
      break;
  }
  return formattedVal
}
function getPaymentInfoTitle (info) {
  return info.value ? formatPaymentMethodNumber(info) : info.title;
}
function getPaymentInfoFullTitle (info) {
  return `${info.value ? info.value : info.title} (${info.note})`;
}
function invoiceGetAmountTitle (ccy, balanceValue, invoice, isPayment = false) {
  const prefix = `Сумма${isPayment ? ' к оплате' : ''}, ${ccy}`
  if (balanceValue) {
    const sign = balanceValue < 0 ? '-' : '+'
    return `${prefix} (${invoice.confirmation.amount} ${sign} ${Math.abs(balanceValue)})`
  }
  return prefix
}
function invoiceGetToBalanceTitle (ccy, balanceValue, isPayment = false) {
  const prefix = balanceValue > 0 ? 'Вернуть долг организатору' : `Списать с баланса${isPayment ? ' в счет оплаты заказа' : ''}`
  return `${prefix} (${balanceValue} ${ccy})`
}
function getPickupPointTitle (point) {
  return point.title + (point.shortTitle ? ` (${point.shortTitle})`  : '');
}
function invoiceInit(invoiceRs) {
  const invoice = invoiceRs
  if (!invoice.confirmation && invoice.status !== 'needConfirm') {
    invoice.confirmation = {}
  } else if (invoice.confirmationPrepayment && !invoice.isPrepayed) {
    invoice.confirmation = invoice.confirmationPrepayment
  }
  if (invoice.confirmation.date) {
    invoice.confirmation.date = new Date(invoice.confirmation.date)
  } else {
    invoice.confirmation.date = new Date()
  }

  if (!invoice.confirmation.amount) invoice.confirmation.amount = _getInvoiceConfirmationAmount(invoice)

  return invoice
}
function padWithZero (initial, resultLength = 2) {
  return ('' + initial).padStart(resultLength, '0')
}
function replaceToBr (text) {
  return text && text.replace(/\n/g, '<br />') || '';
}
function showToast (text) {
  setSnackbarMessage(null)
  setTimeout(() => setSnackbarMessage(text), 0)
}
function toBalanceCalc (invoice, balance) {
  invoice.confirmation.amount = _getInvoiceConfirmationAmount(invoice)
  if (invoice.confirmation.toBalance || balance) {
    return {
      active: !!invoice.confirmation.toBalance,
      value: invoice.confirmation.amount > balance ? -1 * balance : -1 * invoice.confirmation.amount,
      amountReal: invoice.confirmation.amountReal
    }
  }
  return null
}
function toBalanceToggle (balance, invoice, toBalance) {
  if (toBalance && toBalance.active){
    invoice.confirmation.amount = _getInvoiceConfirmationAmount(invoice)
    toBalance.amountReal = invoice.confirmation.amount > balance ? Math.round( (invoice.confirmation.amount - balance) * 100) / 100 : 0
  }
}
function _getInvoiceConfirmationAmount (invoice) {
  if (!invoice.prepayment && !invoice.isPrepayed) {
    return invoice.amount
  }
  if (invoice.prepayment && !invoice.isPrepayed) {
    return invoice.prepayment.from
  }
  if (invoice.isPrepayed && !invoice.amountDiff) {
    return Math.round((invoice.amount - invoice.confirmationPrepayment.amount) * 100) / 100
  }
  if (invoice.isPrepayed && invoice.amountDiff) {
    let actualAmount = invoice.amount - invoice.amountDiff
    let forFullPayment = actualAmount - invoice.confirmationPrepayment.amount
    if (forFullPayment > 0) {
      return Math.round(forFullPayment * 100) / 100
    }
    if (forFullPayment <= 0) {
      return 0
    }
  }
}
function _formatAccountNumber (number, country = 'ru') {
  if (!number) {
    return '';
  }
  let firstAcc;
  let secondAcc;
  let thirdAcc;
  let fourthAcc;
  let fifthAcc;
  let sixthAcc;
  let seventhAcc;

  switch (country) {
    case 'ru':
      firstAcc = number.substr(0, 3);
      secondAcc = number.substr(3, 2);
      thirdAcc = number.substr(5, 3);
      fourthAcc = number.substr(8, 1);
      fifthAcc = number.substr(9, 4);
      sixthAcc = number.substr(13);
      return `${firstAcc} ${secondAcc} ${thirdAcc} ${fourthAcc} ${fifthAcc} ${sixthAcc}`;
    case 'bel':
      firstAcc = number.substr(0, 4);
      secondAcc = number.substr(4, 4);
      thirdAcc = number.substr(8, 4);
      fourthAcc = number.substr(12, 4);
      fifthAcc = number.substr(16, 4);
      sixthAcc = number.substr(20, 4);
      seventhAcc = number.substr(24);
      return `${firstAcc} ${secondAcc} ${thirdAcc} ${fourthAcc} ${fifthAcc} ${sixthAcc} ${seventhAcc}`;
    case 'ukr':
      firstAcc = number.substr(0, 4);
      secondAcc = number.substr(4, 6);
      thirdAcc = number.substr(10, 3);
      fourthAcc = number.substr(13, 4);
      fifthAcc = number.substr(17, 4);
      sixthAcc = number.substr(21, 4);
      seventhAcc = number.substr(25);
      return `${firstAcc} ${secondAcc} ${thirdAcc} ${fourthAcc} ${fifthAcc} ${sixthAcc} ${seventhAcc}`;
    default:
      return `${number}`;
  }
}
function _formatCardNumber (number) {
  const firstCard = number.substr(0, 4);
  const secondCard = number.substr(4, 4);
  const thirdCard = number.substr(8, 4);
  const fourthCard = number.substr(12);
  return `${firstCard} ${secondCard} ${thirdCard} ${fourthCard}`;
}
function formatPhoneNumber (number) {
  if (!number) {
    return '';
  }
  let code;
  let zero;
  let first;
  let second;
  let third;

  if (number.startsWith('+7') || number.startsWith('+8') || number.startsWith('8')) {
    code = '+7'
    number = number.startsWith('+') ? number.substring(2) : number.substring(1);
    zero = number.substring(0, 3);
    first = number.substring(3, 6);
    second = number.substring(6, 8);
    third = number.substring(8);
    return `${code} (${zero}) ${first}-${second}-${third}`;
  } else if (number.startsWith('+375') || number.startsWith('375')) {
    code = '+375';
  } else if (number.startsWith('+380') || number.startsWith('380')) {
    code = '+380';
  }
  number = number.startsWith('+') ? number.substring(3) : number.substring(3);
  zero = number.substring(0, 2);
  first = number.substring(2, 5);
  second = number.substring(5, 7);
  third = number.substring(7);
  return `${code} ${zero} ${first}-${second}-${third}`;
}

function parsePhoneNumber (number) {
  const parsed = {}
  phone.codes.forEach(code => {
    if (number.startsWith(code)) {
      parsed.code = code
      parsed.number = number.substring(code.length)
    }
  });
  return parsed
}

export {
  copyToClipboard,
  fillDialogPosition,
  formatPhoneNumber,
  getPaymentInfoTitle,
  getPaymentInfoFullTitle,
  getPickupPointTitle,
  invoiceGetAmountTitle,
  invoiceGetToBalanceTitle,
  invoiceInit,
  padWithZero,
  parsePhoneNumber,
  replaceToBr,
  showToast,
  toBalanceCalc,
  toBalanceToggle
};
